/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  ErrorHttpContentDto,
  NotificationConfigurationFeatureModelDto,
  ThresholdCollectionDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class AlertClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags AddThresholdAlerts
   * @name AddThresholdAlertsPost
   * @summary Adds threshold alert(s).
   * @request POST:/Alert/Thresholds/Add
   */
  addThresholdAlertsPost = (
    data: ThresholdCollectionDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ThresholdCollectionDto, ErrorHttpContentDto>({
      path: `/Alert/Thresholds/Add`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags DeleteThresholdAlerts
   * @name DeleteThresholdAlertsPost
   * @summary Deletes threshold alert(s).
   * @request DELETE:/Alert/Thresholds/Delete
   */
  deleteThresholdAlertsPost = (
    data: ThresholdCollectionDto,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, ErrorHttpContentDto>({
      path: `/Alert/Thresholds/Delete`,
      method: "DELETE",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags GetThresholdAlert
   * @name GetThresholdAlertGet
   * @summary Gets a threshold alert.
   * @request GET:/Alert/Threshold/{thresholdId}
   */
  getThresholdAlertGet = (thresholdId: string, params: RequestParams = {}) =>
    this.http.request<
      NotificationConfigurationFeatureModelDto,
      ErrorHttpContentDto
    >({
      path: `/Alert/Threshold/${thresholdId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags GetThresholdAlerts
   * @name GetThresholdAlertsGet
   * @summary Gets the user's threshold alerts.
   * @request GET:/Alert/Thresholds
   */
  getThresholdAlertsGet = (params: RequestParams = {}) =>
    this.http.request<ThresholdCollectionDto, ErrorHttpContentDto>({
      path: `/Alert/Thresholds`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SaveThresholdAlerts
   * @name SaveThresholdAlertsPost
   * @summary Saves threshold alert(s).
   * @request POST:/Alert/Thresholds/Save
   */
  saveThresholdAlertsPost = (
    data: ThresholdCollectionDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ThresholdCollectionDto, ErrorHttpContentDto>({
      path: `/Alert/Thresholds/Save`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags UpdateThresholdAlerts
   * @name UpdateThresholdAlertsPost
   * @summary Updates threshold alert(s).
   * @request POST:/Alert/Thresholds/Update
   */
  updateThresholdAlertsPost = (
    data: ThresholdCollectionDto,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, ErrorHttpContentDto>({
      path: `/Alert/Thresholds/Update`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
